import * as helpers from './helpers'

const defaultListReducerForApmaina = helpers.createListReducer({listViewName: 'datnu_apmaina_view', actionsName: 'datnu_apmaina'})
const defaultEditReducerForApmaina = helpers.createEditReducer({editViewName: 'datnu_apmaina_view', actionsName: 'datnu_apmaina'})
export const datnu_apmaina = (state = helpers.listEditGetInitialState(), {type, payload, reqId}) => {

    const stateAfterList = defaultListReducerForApmaina({state, type, payload, reqId})
    return defaultEditReducerForApmaina({state: stateAfterList, type, payload, reqId})
}